<template>
  <li class="dropdown_menu" :class="mainExamListCssObj">
    <a v-b-toggle.examCollapse>
      <b-icon-file-text-fill></b-icon-file-text-fill>
      <span class="link-title menu_hide ml-1">ข้อสอบ</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="examCollapse" :visible="false" accordion="accordion">
      <main-exam-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainExamCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainExamCollapseMenu,
  },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
    };
  },
  computed: {
    mainExamListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  watch: {},
  mounted() {
    if (checkSubMenuAccess({ menu: "exam-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการข้อสอบ",
        to: {
          name: "exam.build",
        },
        iconClass: "fas fa-book",
      });
    }
    if (checkSubMenuAccess({ menu: "exam-overview" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "สรุปภาพรวมข้อสอบ",
        to: {
          name: "analytics.exam.overview",
        },
        iconClass: "fas fa-book",
      });
    }
    if (
      checkSubMenuAccess({ menu: "exam-answersheet" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "กระดาษคำตอบ",
        to: {
          name: "analytics-answer-sheet-list",
        },
        iconClass: "fas fa-book",
      });
    }
    if (checkSubMenuAccess({ menu: "exam-upload" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "อัปโหลดข้อสอบ",
        to: {
          name: "company.exam-management.upload",
        },
        meta: {
          module: "exam-management",
        },
        iconClass: "fas fa-book",
      });
    }
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
